var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.88002 10.2947L0.330017 5.74474C0.0566611 5.47138 0.0566611 5.02817 0.330017 4.75478L1.31994 3.76483C1.5933 3.49145 2.03654 3.49145 2.3099 3.76483L5.37499 6.8299L11.9401 0.264831C12.2134 -0.00852441 12.6567 -0.00852441 12.93 0.264831L13.92 1.25478C14.1933 1.52814 14.1933 1.97135 13.92 2.24474L5.86997 10.2948C5.59659 10.5681 5.15337 10.5681 4.88002 10.2947Z",
    fill: "#48bb78"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickGreen);
export default __webpack_public_path__ + "static/media/tick-green.f678c7f54b2f091cfbea2b0ba1863d0a.svg";
export { ForwardRef as ReactComponent };